'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardHeader from 'UIComponents/card/UICardHeader';
import UICardSection from 'UIComponents/card/UICardSection';
export default function Accordion(props) {
  return /*#__PURE__*/_jsxs(UICardWrapper, {
    expandable: true,
    defaultExpanded: true,
    compact: true,
    children: [/*#__PURE__*/_jsx(UICardHeader, {
      title: props.title,
      titleSize: "extra-small"
    }), /*#__PURE__*/_jsx(UICardSection, {
      children: props.children
    })]
  });
}
Accordion.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired
};